import GrowthDashboardHeader from '@/components/page/Growth/Dashboard/GrowthDashboardHeader';
import GrowthDashboardMap from '@/components/page/Growth/Dashboard/GrowthDashboardMap';
import PageHeader from '@components/common/PageHeader';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
    GrowthDashboardMidCardInfo,
    GrowthDashboardReq,
    GrowthDashboardTopCardInfo,
} from '@/api/growth/dashboard/type';
import { api } from '@/api/growth/dashboard/api';
import GrowthDashboardCard from '@components/page/Growth/Dashboard/GrowthDashboardCard';
import GrowthDashboardProgCard from '@components/page/Growth/Dashboard/GrowthDashboardProgCard';
import GrowthLaiInfoCard from '@components/page/Growth/Dashboard/GrowthLaiInfoCard';
import GrowthTempInfoCard from '@components/page/Growth/Dashboard/GrowthTempInfoCard';
import GrowthYieldWeightInfoCard from '@components/page/Growth/Dashboard/GrowthYieldWeightInfoCard';
import GrowthGrowingWeightInfoCard from '@/components/page/Growth/Dashboard/GrowthGrowingWeightInfoCard';
import GrowthGrowingSizeInfoCard from '@components/page/Growth/Dashboard/GrowthGrowingSizeInfoCard';
import GrowthNitrogenInfoCard from '@components/page/Growth/Dashboard/GrowthNitrogenInfoCard';
import GrowthLightInterceptionInfoCard from '@components/page/Growth/Dashboard/GrowthDashboardLightInterceptionCard';
import GrowthPhosphoricAcidInfoCard from '@/components/page/Growth/Dashboard/GrowthPhosphoricAcidInfoCard';
import GrowthDashboardRespCard from '@components/page/Growth/Dashboard/GrowthDashboardRespCard';
import GrowthDashboardNutrientFractionationCard from '@/components/page/Growth/Dashboard/GrowthDashboardNutrientFractionationCard';
import GrowthDashboardSoilLayerMoistureCard from '@components/page/Growth/Dashboard/GrowthDashboardSoilLayerMoistureCard';
import GrowthDashboardWeatherCard from '@/components/page/Growth/Dashboard/GrowthDashboardWeatherCard';
import GrowthDashboardSoilInfoCard from '@/components/page/Growth/Dashboard/GrowthDashboardSoilInfoCard';
import GrowthDashboardFarmingRecomCard from '@/components/page/Growth/Dashboard/ GrowthDashboardFarmingRecomCard';

const GrowthDashboard = () => {
    const { gfIdx } = useParams<{ gfIdx?: string }>();
    const paramIdx = gfIdx ? Number(gfIdx) : undefined;
    const [_gfIdx, _setGfIdx] = useState(paramIdx);
    const [loading, setLoading] = useState(true);

    const [topCardInfo, setTopCardInfo] =
        useState<GrowthDashboardTopCardInfo | null>(null);

    const [midCardInfo, setMidCardInfo] =
        useState<GrowthDashboardMidCardInfo | null>(null);

    useEffect(() => {
        if (gfIdx) {
            fetchTopCardInfo(Number(gfIdx));
            fetchMidCardInfo(Number(gfIdx));
        }
    }, [gfIdx]);

    const fetchTopCardInfo = async (gfIdx: number) => {
        setLoading(true);
        const req: GrowthDashboardReq = { gfIdx };
        const response = await api.getTopCardInfo(req);
        setTopCardInfo(response.data);
        setLoading(false);
    };

    const fetchMidCardInfo = async (gfIdx: number) => {
        setLoading(true);
        const req: GrowthDashboardReq = { gfIdx };
        const response = await api.getMidCardInfo(req);
        setMidCardInfo(response.data);
        setLoading(false);
    };

    return (
        <div className="dashboard-ui">
            <PageHeader
                title="생육대시보드"
                breadcrumbs={[
                    { label: '홈', href: '/' },
                    { label: '생육관리' },
                    { label: '생육대시보드', active: true },
                ]}
            />
            <div className="row mt-4">
                <div className="col-12 col-md-6">
                    {loading ? (
                        <div>로딩중...</div>
                    ) : (
                        topCardInfo && (
                            <GrowthDashboardHeader topCardInfo={topCardInfo} />
                        )
                    )}
                </div>
                <div className="col-12 col-md-6">
                    {loading ? (
                        <div>로딩중...</div>
                    ) : (
                        topCardInfo && (
                            <GrowthDashboardMap
                                lat={topCardInfo.lat}
                                lon={topCardInfo.lon}
                                cropName={topCardInfo.gcName} // 이 부분 추가
                            />
                        )
                    )}
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-md-3 col-xxl-2">
                    <GrowthDashboardCard
                        cardInfo={midCardInfo}
                        displayType={1}
                    />
                </div>
                <div className="col-12 col-md-3 col-xxl-2">
                    <GrowthDashboardCard
                        cardInfo={midCardInfo}
                        displayType={2}
                    />
                </div>
                <div className="col-12 col-md-3 col-xxl-2">
                    <GrowthDashboardCard
                        cardInfo={midCardInfo}
                        displayType={3}
                    />
                </div>
                <div className="col-12 col-md-3 col-xxl-2">
                    <GrowthDashboardCard
                        cardInfo={midCardInfo}
                        displayType={4}
                    />
                </div>
                <div className="col-12 col-md-3 col-xxl-2">
                    <GrowthDashboardCard
                        cardInfo={midCardInfo}
                        displayType={5}
                    />
                </div>
                <div className="col-12 col-md-3 col-xxl-2">
                    <GrowthDashboardCard
                        cardInfo={midCardInfo}
                        displayType={6}
                    />
                </div>

                <div className="col-12 col-md-3 col-xxl-2">
                    <GrowthDashboardProgCard
                        cardInfo={midCardInfo}
                        displayType={1}
                    />
                </div>
                <div className="col-12 col-md-3 col-xxl-2">
                    <GrowthDashboardProgCard
                        cardInfo={midCardInfo}
                        displayType={2}
                    />
                </div>
                <div className="col-12 col-md-3 col-xxl-2">
                    <GrowthDashboardProgCard
                        cardInfo={midCardInfo}
                        displayType={3}
                    />
                </div>

                <div className="col-12 col-md-3 col-xxl-2">
                    <GrowthDashboardProgCard
                        cardInfo={midCardInfo}
                        displayType={4}
                    />
                </div>
                <div className="col-12 col-md-3 col-xxl-2">
                    <GrowthDashboardProgCard
                        cardInfo={midCardInfo}
                        displayType={5}
                    />
                </div>
                <div className="col-12 col-md-3 col-xxl-2">
                    <GrowthDashboardProgCard
                        cardInfo={midCardInfo}
                        displayType={6}
                    />
                </div>
                <div className="col-12 col-xxl-2">
                    <GrowthDashboardProgCard
                        cardInfo={midCardInfo}
                        displayType={7}
                    />
                </div>

                <div className="col-12 col-xxl-2">
                    {paramIdx && (
                        <GrowthLightInterceptionInfoCard gfIdx={paramIdx} />
                    )}
                </div>

                <div className="col-12 col-xxl-2">
                    {paramIdx && <GrowthLaiInfoCard gfIdx={paramIdx} />}
                </div>

                <div className="col-12 col-md-3 col-xxl-3">
                    {paramIdx && <GrowthTempInfoCard gfIdx={paramIdx} />}
                </div>

                <div className="col-12 col-md-3 col-xxl-3">
                    {paramIdx && <GrowthYieldWeightInfoCard gfIdx={paramIdx} />}
                </div>

                <div className="col-12">
                    <div className="row mb-4">
                        <div className="col-9">
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    {paramIdx && (
                                        <GrowthGrowingWeightInfoCard
                                            gfIdx={paramIdx}
                                        />
                                    )}
                                </div>

                                <div className="col-12 col-md-6">
                                    {paramIdx && (
                                        <GrowthGrowingSizeInfoCard
                                            gfIdx={paramIdx}
                                        />
                                    )}
                                </div>

                                <div className="col-12 col-md-3">
                                    {paramIdx && (
                                        <GrowthNitrogenInfoCard
                                            gfIdx={paramIdx}
                                        />
                                    )}
                                </div>
                                <div className="col-12 col-md-3">
                                    {paramIdx && (
                                        <GrowthPhosphoricAcidInfoCard
                                            gfIdx={paramIdx}
                                        />
                                    )}
                                </div>

                                <div className="col-12 col-md-6">
                                    {paramIdx && (
                                        <GrowthDashboardRespCard
                                            gfIdx={paramIdx}
                                        />
                                    )}
                                </div>

                                <div className="col-12 col-md-6">
                                    {paramIdx && (
                                        <GrowthDashboardNutrientFractionationCard
                                            gfIdx={paramIdx}
                                        />
                                    )}
                                </div>

                                <div className="col-12 col-md-6">
                                    {paramIdx && (
                                        <GrowthDashboardSoilLayerMoistureCard
                                            gfIdx={paramIdx}
                                        />
                                    )}
                                </div>

                                <div className="col-12">
                                    {paramIdx && (
                                        <GrowthDashboardWeatherCard
                                            gfIdx={paramIdx}
                                        />
                                    )}
                                </div>

                                <div className="col-12">
                                    {paramIdx && (
                                        <GrowthDashboardSoilInfoCard
                                            gfIdx={paramIdx}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-3">
                            {paramIdx && (
                                <GrowthDashboardFarmingRecomCard
                                    gfIdx={paramIdx}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GrowthDashboard;
